import { Button, Modal, Radio } from "antd";
import { useState } from "react";
import useWsSender from "lib/wsSenderHook";
import { showToast } from "ui/components/common";

export default function ({ deviceId, orgId }) {
  const [forced, setForced] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const { sendWsRequest } = useWsSender();
  const deviceForward = async () => {
    try {
      setLoading(true);
      await sendWsRequest(
        "device.disk_format",
        {
          diskFormat: {
            deviceId: deviceId.toString(),
          },
        },
        { orgId },
      );
      showToast(0, "Disk format request sent");
      setLoading(false);
      setModalShow(false);
    } catch (e) {
      setLoading(false);
      console.error(e);
      showToast(1, "Disk format request failed");
    }

    return;
  };
  return (
    <>
      <Button onClick={() => setModalShow(true)} type="link">
        Disk Format
      </Button>
      <Modal
        title={"Disk Format"}
        open={modalShow}
        okText="Confirm"
        okButtonProps={{ className: "primaryButton", loading }}
        cancelButtonProps={{ className: "primaryButton bordered" }}
        onCancel={() => setModalShow(false)}
        onOk={deviceForward}
      >
        <div>Format Disk ?</div>
      </Modal>
    </>
  );
}
